import NodeComponent from './NodeComponent'

class BlockNodeComponent extends NodeComponent {
  // maybe someday we need some BlockNode specific rendering
}

export default BlockNodeComponent
